import React from 'react';
import CardList from './CardList';
import DisclaimerFooter from './DisclaimerFooter';

interface ImportantUpdate {
    heading: string;
    body: string;
    learnMoreText?: string;
    learnMoreUrl?: string;
}

interface Disclaimers {
    footer: string[];
    importantUpdate?: ImportantUpdate;
}

interface SelectorContentProps {
    initialCardData: {
        [key: string]: any;
        disclaimers: Disclaimers;
    };
}

/**
 * Renders the main content for the card selector tool
 * Displays a list of credit cards and footer using CardList and Footer component
 * Takes in initialCardData as a prop which should contain card objects and a footer array.
 * Returns null if no card data is provided.
 */
const SelectorContent: React.FC<SelectorContentProps> = ({ initialCardData }) => {
    if (!initialCardData || !Object.keys(initialCardData).length) return null;

    return (
        <>
            <CardList cardData={initialCardData} />
            <DisclaimerFooter footer={initialCardData.disclaimers.footer} />
        </>
    );
};

export default SelectorContent;
